module.exports = __webpack_public_path__ + "media/images/lesson_7/sebastiao_cesta-8f8225ce03531f6773c62be63176c61b.png";